import { createApp } from 'vue';
import App from './App.vue';
import PrimeVue from 'primevue/config';
import router from './router';
import './assets/styles/global.css';
import { definePreset } from '@primevue/themes'

import Lara from '@primevue/themes/lara';

const MyPreset  = definePreset (Lara, {
    components: {
        card: {
            colorScheme: {
                light: {
                    root: {
                        background: '{surface.0}',
                        color: '{surface.700}'
                    },
                    subtitle: {
                        color: '{surface.500}'
                    }
                },
                dark: {
                    root: {
                        background: '{surface.900}',
                        color: '{surface.0}'
                    },
                    subtitle:{
                        color: '{surface.400}'
                    }
                }
            }
        }
    }
})

const app = createApp(App);
app.use(router);

app.use(PrimeVue, {
    theme: {
        preset: MyPreset
    }
});

//app.provide('msalInstance', msalInstance);
app.mount('#app');
